'kiwi public';

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { escape } from 'lodash';
import getState from '@/libs/state';
export function matchEmoji(word) {
  var emojis = this.getEmojis(word);
  if (!emojis.length) {
    return false;
  }
  return [{
    index: 0,
    match: word,
    type: 'emoji',
    meta: {
      emoji: emojis[0].code
    }
  }];
}
export function blockToHtml(block, isSingle, showEmoticons) {
  var _context, _context2, _context3, _context4;
  if (!showEmoticons) {
    return block.content;
  }
  var emojiLocation = getState().setting('emojiLocation');
  var emoji = block.meta.emoji;
  var classes = 'kiwi-messagelist-emoji' + (isSingle ? ' kiwi-messagelist-emoji--single' : '');
  var src = _concatInstanceProperty(_context = "".concat(emojiLocation)).call(_context, emoji);
  return _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "<img class=\"".concat(classes, "\" src=\"")).call(_context4, src, "\" alt=\"")).call(_context3, escape(block.content), "\" title=\"")).call(_context2, escape(block.content), "\" />");
}
export function getEmojis(word) {
  var emojiList = getState().setting('emojis');
  var emojiLocation = getState().setting('emojiLocation');
  if (!Object.prototype.hasOwnProperty.call(emojiList, word)) {
    return [];
  }
  return [{
    ascii: word,
    code: emojiList[word],
    url: emojiLocation + emojiList[word]
    // imgProps allows setting properties of <img>
  }];
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["EmojiProvider"]
window._kiwi_exports.libs.EmojiProvider = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
